import * as Mui from '@mui/material';
import { Route, Routes } from 'react-router';

import { SupplierCustomGroupLocation } from '../component/supplier-custom-group-location/SupplierCustomGroupLocation';
import { GenericTitleHeader } from '../component/common/GenericTitleHeader';
import useOperationTranslation from '../hooks/useOperationTranslation';
import SectionHeader from '../../../util/component/SectionHeader';

const SupplierCustomGroupLocationPage = () => {
    const t = useOperationTranslation();
    return (
        <Mui.Box>
           <SectionHeader
                title={t("supplierCustomGroupLocation.title") + " " + t("supplierCustomGroupLocation.description")}
            />	
            <Routes>
                <Route index={true} element={<SupplierCustomGroupLocation />} />
            </Routes>
        </Mui.Box>
    );
};

export default SupplierCustomGroupLocationPage;
